import React from 'react';
import { EventEmmiterProvider, useEventEmmiter } from './eventEmmiter';
import { EditorStateProvider, useEditorState } from './state';
import { ActionsProvider, useActions } from './actions';
import {
  ModalManagerProvider,
  useModalActions,
  useModalState,
} from './modalManager';
import { EditorWatchProvider, useEditorWatch } from './editorWatch';

const Provider = ({ value, actions, children }) => {
  return (
    <EventEmmiterProvider>
      <EditorStateProvider value={value}>
        <ProvidersWithEmmiter>
          <ActionsProvider value={actions}>{children}</ActionsProvider>
        </ProvidersWithEmmiter>
      </EditorStateProvider>
    </EventEmmiterProvider>
  );
};

function ProvidersWithEmmiter({ children }) {
  const emmiterOptions = useEventEmmiter();

  return (
    <ModalManagerProvider emmiterOptions={emmiterOptions}>
      <EditorWatchProvider emmiterOptions={emmiterOptions}>
        {children}
      </EditorWatchProvider>
    </ModalManagerProvider>
  );
}

export {
  Provider,
  useModalState,
  useModalActions,
  useEditorWatch,
  useActions,
  useEditorState,
};
